export interface LoadingSpinnerProps {
  size?: number;
  message?: string;
}

const sizeClasses: Record<number, string> = {
  16: 'h-4 w-4 border-2',
  24: 'h-5 w-5 border-2',
  32: 'h-7 w-7 border-2',
  48: 'h-10 w-10 border-[3px]',
};

export function LoadingSpinner({ size = 24, message }: LoadingSpinnerProps) {
  const cls = sizeClasses[size] ?? 'h-5 w-5 border-2';

  return (
    <div
      role="status"
      aria-label={message ?? 'Loading'}
      className="flex flex-col items-center justify-center gap-2.5 py-8"
    >
      <div
        className={`${cls} border-border border-t-baker-accent rounded-full animate-spin`}
      />
      {message && (
        <span className="text-xs text-text-muted">{message}</span>
      )}
    </div>
  );
}
